import { Button } from "primereact/button";

import type { Embarcacao } from "@/modules/embarcacoes";
import {
  ACTION_TOOLTIP_OPTIONS,
  DETAIL_ACTION_TOOLTIP,
} from "@/screens/control-panel/components/action-tooltip";
import styles from "./embarcacao-row-actions.module.scss";

interface EmbarcacaoRowActionsProps {
  embarcacao: Embarcacao;
  /**
   * Único ponto de extensão da coluna de ação: abre o modal de Detalhes da
   * Embarcação sobre a listagem, sem alterar a tabela (AC1).
   */
  onDetail?: (embarcacao: Embarcacao) => void;
}

/** Rótulo acessível que identifica a embarcação da linha (AC5). */
function detailActionLabel(embarcacao: Embarcacao): string {
  return `Detalhar embarcação ${embarcacao.nome || embarcacao.acronimo}`;
}

/**
 * Ação de consulta da linha (AC1).
 *
 * A lupa abre o detalhamento **sobre a listagem**: não navega para outra rota
 * nem altera busca, filtros, ordenação ou página. `aria-haspopup` só é
 * anunciado quando há um diálogo a abrir — sem `onDetail`, acioná-la não
 * produz efeito algum.
 */
export function EmbarcacaoRowActions({ embarcacao, onDetail }: EmbarcacaoRowActionsProps) {
  return (
    <div className={styles.rowActions}>
      <Button
        type="button"
        className={styles.rowActionButton}
        icon="pi pi-search"
        aria-label={detailActionLabel(embarcacao)}
        aria-haspopup={onDetail ? "dialog" : undefined}
        tooltip={DETAIL_ACTION_TOOLTIP}
        tooltipOptions={{ ...ACTION_TOOLTIP_OPTIONS, event: "hover" }}
        onClick={onDetail ? () => onDetail(embarcacao) : undefined}
        data-testid={`embarcacoes-detail-${embarcacao.id}`}
        text
      />
    </div>
  );
}
